import React, { useEffect, useState, useRef } from "react";
import { withTranslation } from "react-i18next";
import App_Constants from "../../app-constants/App_Constants";
import CONFIG_OBJECT from "../../config/config";
import { postDataFetcher } from "../../dataFetcher";
import "./diaper-size-calculator-css/diaper-size-calculator.css";
import DiaperSizeCalculatorLanding from "./diaper-size-calculator-landing/landing";
import DiaperSizeCalculatorResult from "./diaper-size-calculator-result/result";
import Loader from "./loader/Loader";
import { isMobile } from "react-device-detect";

const DiaperSizeCalculator = (props) => {
  const [componentData, setComponentData] = useState();
  const [diaperCalculatorData, setDiaperCalculatorData] = useState({
    showResult: false,
    apiData: {},
    eventType: "",
    loader: false,
  });

  // scroll to element function
  const resultRef = useRef(null);
  const executeScroll = () =>
    resultRef.current.scrollIntoView({ behavior: "smooth", block: "start" });

  // Calling Layout Service and Caching the response
  useEffect(() => {
    let componentData = props.fields;
    // console.log("componentData", componentData);
    setComponentData(componentData);
  }, []);

  // handle child form data
  let diaperCalcData = {
    babyHeightUnit: "",
    babyWeightUnit: "",
    brandId: "",
    babyHeight: 0,
    babyWeight: 0,
    eventId: "",
    eventType: "",
    tripDuration: 0,
    heightUnit: "",
  };
  const diaperSizeData = (
    babyHeightUnit,
    babyWeightUnit,
    brandId,
    babyHeight,
    babyWeight,
    eventId,
    eventType,
    tripDuration,
    heightUnit
  ) => {
    diaperCalcData = {
      babyHeightUnit: babyHeightUnit,
      babyWeightUnit: babyWeightUnit,
      brandId: brandId,
      babyHeight: babyHeight,
      babyWeight: babyWeight,
      eventId: eventId,
      eventType: eventType,
      tripDuration: tripDuration,
      heightUnit: heightUnit,
    };
    // console.log("diaperCalcData", diaperCalcData);
  };

  const submitHandler = (e) => {
    e.preventDefault();
  };

  // handle form submit
  const handleCalculateDiaperSize = () => {
    // enable loading
    setDiaperCalculatorData({
      loader: true,
    });

    // converting baby height from feet'inches to decimal
    if (diaperCalcData.heightUnit === "Feet") {
      let babtHeightInFeet = diaperCalcData.babyHeight;
      var babyHeight = babtHeightInFeet.replace(/'/g, ".");
    } else {
      var babyHeight = diaperCalcData.babyHeight;
    }

    if (diaperCalcData.eventType === "Predict Diaper Size") {
      let restUrl = `${CONFIG_OBJECT.DIAPER_SIZE_FINDER_REST_URL}`;

      let data = {
        BrandId: `{${diaperCalcData.brandId}}`,
        BabyHeight: Number(babyHeight),
        BabyHeightUnit: `{${diaperCalcData.babyHeightUnit}}`,
        BabyWeight: Number(diaperCalcData.babyWeight),
        BabyWeightUnit: `{${diaperCalcData.babyWeightUnit}}`,
        EventId: `{${diaperCalcData.eventId}}`,
      };
      postDataFetcher(`${restUrl}${App_Constants.SC_API_KEY}`, data)
        .then((res) => {
          Promise.resolve();
          // console.log("Predict Diaper Size res", res);
          setDiaperCalculatorData({
            showResult: true,
            apiData: res.data.Data,
            eventType: diaperCalcData.eventType,
            loader: false, // stop loader
          });
          executeScroll();
        })
        .catch((err) => {
          if (err.response) {
            // client received an error response (5xx, 4xx)
            console.log("Response error: ", err.response);
          } else if (err.request) {
            // client never received a response, or request never left
            console.log("Request error: ", err.request);
          } else {
            // anything else
            console.log(err);
          }
          setDiaperCalculatorData({
            loader: false, // stop loader
          });
        });
    } else if (diaperCalcData.eventType === "Diaper Per Day") {
      let restUrl = `${CONFIG_OBJECT.DIAPERS_PER_DAY_REST_URL}`;
      let data = {
        BrandId: `{${diaperCalcData.brandId}}`,
        BabyHeight: Number(babyHeight),
        BabyHeightUnit: `{${diaperCalcData.babyHeightUnit}}`,
        BabyWeight: Number(diaperCalcData.babyWeight),
        BabyWeightUnit: `{${diaperCalcData.babyWeightUnit}}`,
        EventId: `{${diaperCalcData.eventId}}`,
      };
      postDataFetcher(`${restUrl}${App_Constants.SC_API_KEY}`, data)
        .then((res) => {
          Promise.resolve();
          // console.log("Diaper Per Day res", res);
          setDiaperCalculatorData({
            showResult: true,
            apiData: res.data.Data,
            eventType: diaperCalcData.eventType,
            loader: false, // stop loader
          });
          executeScroll();
        })
        .catch((err) => {
          if (err.response) {
            // client received an error response (5xx, 4xx)
            console.log("Response error: ", err.response);
          } else if (err.request) {
            // client never received a response, or request never left
            console.log("Request error: ", err.request);
          } else {
            // anything else
            console.log(err);
          }
          setDiaperCalculatorData({
            loader: false, // stop loader
          });
        });
    } else if (diaperCalcData.eventType === "Diaper For Trip") {
      let restUrl = `${CONFIG_OBJECT.DIAPERS_PER_TRIP_REST_URL}`;
      let data = {
        BrandId: `{${diaperCalcData.brandId}}`,
        BabyHeight: Number(babyHeight),
        BabyHeightUnit: `{${diaperCalcData.babyHeightUnit}}`,
        BabyWeight: Number(diaperCalcData.babyWeight),
        BabyWeightUnit: `{${diaperCalcData.babyWeightUnit}}`,
        EventId: `{${diaperCalcData.eventId}}`,
        TripDuration: Number(diaperCalcData.tripDuration),
      };
      postDataFetcher(`${restUrl}${App_Constants.SC_API_KEY}`, data)
        .then((res) => {
          Promise.resolve();
          // console.log("Diaper For Trip res", res);
          setDiaperCalculatorData({
            showResult: true,
            apiData: res.data.Data,
            eventType: diaperCalcData.eventType,
            loader: false, // stop loader
          });
          executeScroll();
        })
        .catch((err) => {
          if (err.response) {
            // client received an error response (5xx, 4xx)
            console.log("Response error: ", err.response);
          } else if (err.request) {
            // client never received a response, or request never left
            console.log("Request error: ", err.request);
          } else {
            // anything else
            console.log(err);
          }
          setDiaperCalculatorData({
            loader: false, // stop loader
          });
        });
    }
    document.getElementById("btn-calculate").disabled = true;
  };

  return (
    <>
      {componentData && (
        <section className="diaper-size-calc-wrap">
          <div className="container">
            {!isMobile && (
              <p className="description">
                Discover the number of diapers you will need to order in a baby
                show or how many you should have for your baby in a period of
                days.
              </p>
            )}
            <div className="form-container">
              <form onSubmit={submitHandler} noValidate>
                <DiaperSizeCalculatorLanding
                  diaperSizeData={diaperSizeData}
                  componentData={componentData}
                />
                <div className="row">
                  <div className="col-12 text-center">
                    <div className="mt-3">
                      <button
                        className="calculate"
                        id="btn-calculate"
                        onClick={handleCalculateDiaperSize}
                      >
                        Calculate
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <hr className="form-divider" />
          <div className="container">
            <div className="resultblk" ref={resultRef}>
              {diaperCalculatorData.loader && <Loader />}
              {diaperCalculatorData.showResult && (
                <DiaperSizeCalculatorResult
                  componentData={componentData}
                  diaperCalculatorData={diaperCalculatorData}
                />
              )}
            </div>
          </div>
          <div className="calculator-note-section">
            <p>
              Note: Please note that the result is a prediction and not
              necessarily 100% accurate.
            </p>
          </div>
        </section>
      )}
    </>
  );
};

export default withTranslation()(DiaperSizeCalculator);
